import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LibraryHelper } from '@services/helpers/library-helper';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { LibraryPrimeNgModule } from '../../library-primeNg.module';
import { LibraryMenuComponent } from './library-menu.component';

@NgModule({
  declarations: [LibraryMenuComponent],
  imports: [CommonModule, LibraryPrimeNgModule, CommonSharedModule, PipeDirectiveModule],
  exports: [LibraryMenuComponent],
  providers: [LibraryHelper],
})
export class LibraryMenuModule {}
